import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { pathByRouteName } from '../../util/routes';
import { useHistory } from 'react-router-dom';

const useNamedLink = props => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const { name, params = {}, to = {} } = props;

  const pathname = pathByRouteName(name, routeConfiguration, params);

  return {
    moveTo: () => {
      history.push({ pathname, ...to });
    },
  };
};

export default useNamedLink;
